import {
  GET_PRE_REGISTRATION_REJECTIONS,
  GET_PRE_REGISTRATION_REJECTIONS_FAIL,
  GET_PRE_REGISTRATION_REJECTIONS_SUCCESS,
  ADD_NEW_PRE_REGISTRATION_REJECTION,
  ADD_NEW_PRE_REGISTRATION_REJECTION_SUCCESS,
  ADD_NEW_PRE_REGISTRATION_REJECTION_FAIL,
  UPDATE_PRE_REGISTRATION_REJECTION,
  UPDATE_PRE_REGISTRATION_REJECTION_SUCCESS,
  UPDATE_PRE_REGISTRATION_REJECTION_FAIL,
  DELETE_PRE_REGISTRATION_REJECTION,
  DELETE_PRE_REGISTRATION_REJECTION_SUCCESS,
  DELETE_PRE_REGISTRATION_REJECTION_FAIL,
  
} from "./actionTypes";

export const getPreRegistrationRejections = () => ({
  type: GET_PRE_REGISTRATION_REJECTIONS,
})

export const getPreRegistrationRejectionsSuccess = (preRegistrationRejections) => ({
  type: GET_PRE_REGISTRATION_REJECTIONS_SUCCESS,
  payload: preRegistrationRejections,
})

export const getPreRegistrationRejectionsFail = error => ({
  type: GET_PRE_REGISTRATION_REJECTIONS_FAIL,
  payload: error,
})

export const addNewPreRegistrationRejection = (preRegistrationRejection) => ({
  type: ADD_NEW_PRE_REGISTRATION_REJECTION,
  payload: preRegistrationRejection,
})

export const addNewPreRegistrationRejectionSuccess = (preRegistrationRejection) => ({
  type: ADD_NEW_PRE_REGISTRATION_REJECTION_SUCCESS,
  payload: preRegistrationRejection,
})

export const addNewPreRegistrationRejectionFail = error => ({
  type: ADD_NEW_PRE_REGISTRATION_REJECTION_FAIL,
  payload: error,
})

export const updatePreRegistrationRejection = (preRegistrationRejection) => ({
  type: UPDATE_PRE_REGISTRATION_REJECTION,
  payload: preRegistrationRejection,
})

export const updatePreRegistrationRejectionSuccess = (preRegistrationRejection) => ({
  type: UPDATE_PRE_REGISTRATION_REJECTION_SUCCESS,
  payload: preRegistrationRejection,
})

export const updatePreRegistrationRejectionFail = error => ({
  type: UPDATE_PRE_REGISTRATION_REJECTION_FAIL,
  payload: error,
})

export const deletePreRegistrationRejection = (preRegistrationRejection) => ({
  type: DELETE_PRE_REGISTRATION_REJECTION,
  payload: preRegistrationRejection,
})

export const deletePreRegistrationRejectionSuccess = (preRegistrationRejection) => ({
  type: DELETE_PRE_REGISTRATION_REJECTION_SUCCESS,
  payload: preRegistrationRejection,
})

export const deletePreRegistrationRejectionFail = error => ({
  type: DELETE_PRE_REGISTRATION_REJECTION_FAIL,
  payload: error,
})

